<template>
  <div class="titan_account_detail_section_container">
    <div class="titan_account_detail_section_header">About</div>
    <div class="titan_account_detail_section_content">
      <div v-for="(category, index) in data" class="section_category" :key="category.categoryId">
        <div class="section_category_title flex_display">
          <div class="div_aline_left">
            {{category.category}}
          </div>
          <div class="div_aline_right flex_display">
            <span class="section_action flex_display" v-on:click="expandCategory(category.categoryId)">
                <div class="flex_display_centered_child flex_display" v-bind:class="{ large_open: !category.isExpand }">
                  <span class="large_expand_arrow_left"></span>
                  <span class="large_expand_arrow_right"></span>
                </div>
              </span>
          </div>
        </div>
        <transition name="expand">
          <div v-if="category.isExpand" v-for="(subCategory, index) in category.detail" class="section_category_content" :key="subCategory.subCategoryId">
            <div class="section_subcategory_title flex_display">
              <div class="div_aline_left">
                {{subCategory.subCategory}}
              </div>
              <div class="div_aline_right flex_display">
              <span class="section_subcategory_action section_subcategory_edit" v-on:click="eidtSubCategory(category.categoryId, subCategory.subCategoryId)">
                <i class="fas fa-pencil-alt"></i>
              </span>
                <span class="section_subcategory_action flex_display" v-on:click="expandSubCategory(category.categoryId, subCategory.subCategoryId)">
                <div class="flex_display_centered_child flex_display" v-bind:class="{ normal_open: !subCategory.isExpand }">
                  <span class="normal_expand_arrow_left"></span>
                  <span class="normal_expand_arrow_right"></span>
                </div>
              </span>
              </div>
            </div>
            <transition name="expand">
              <div v-if="subCategory.isExpand" class="section_subcategory_content">
                <template v-if="subCategory.isEditing">
                  <div v-for="field in subCategory.fields" :key="field.name" class="section_table_cell">
                    <span class="neon_form_label">{{field.displayName}}</span>
                    <input type="text" class="neon_input_text">
                    <span class="neon_form_message"></span>
                  </div>
                </template>

                <template v-else>
                  <div v-for="field in subCategory.fields" :key="field.name" class="section_table_cell">
                    <span class="neon_form_label">{{field.displayName}}</span>
                    <span class="neon_form_value"></span>
                    <span class="neon_form_message"></span>
                  </div>
                </template>
              </div>
            </transition>
            <div v-if="subCategory.isEditing" class="section_subcategory_footer flex_display">
              <span class="section_subcategory_footer_message"></span>
              <button class="neon_btn neon_btn_link section_subcategory_footer_cancel">Cancel</button>
              <button class="neon_btn neon_btn_primary neon_btn_default section_subcategory_footer_save">Save</button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'basicInformation',
    data () {
      return {
        accountId: 9527,
        data: [
          {
            categoryId: 1,
            category: 'About',
            isExpand: true,
            detail: [
              {
                subCategoryId: 1,
                subCategory: 'Name',
                isExpand: true,
                isEditing: false,
                fields: [
                  {
                    name: 'account.prefix',
                    displayName: 'Prefix',
                    type: 'text',
                    validateMethod: ''
                  },
                  {
                    name: 'account.firstName',
                    displayName: 'First name',
                    type: 'text',
                    validateMethod: ''
                  },
                  {
                    name: 'account.middleName',
                    displayName: 'Middle Name',
                    type: 'text',
                    validateMethod: ''
                  },
                  {
                    name: 'account.lastName',
                    displayName: 'Last Name',
                    type: 'text',
                    validateMethod: ''
                  },
                  {
                    name: 'account.suffix',
                    displayName: 'Suffix',
                    type: 'text',
                    validateMethod: ''
                  },
                  {
                    name: 'account.householdName',
                    displayName: 'Household Name',
                    type: 'text',
                    validateMethod: ''
                  },
                  {
                    name: 'account.salutation',
                    displayName: 'Salutation',
                    type: 'text',
                    validateMethod: ''
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    methods: {
      expandCategory: function (index) {
        for (var i = 0; i < this.data.length; i++) {
          if (this.data[i].categoryId === index) {
            this.data[i].isExpand = !this.data[i].isExpand
          }
        }
      },
      expandSubCategory: function (index1, index2) {
        for (var i = 0; i < this.data.length; i++) {
          if (this.data[i].categoryId === index1) {
            for (var j = 0; j < this.data[i].detail.length; j++) {
              if (this.data[i].detail[j].subCategoryId === index2) {
                this.data[i].detail[j].isExpand = !this.data[i].detail[j].isExpand
              }
            }
          }
        }
      },
      eidtSubCategory: function (index1, index2) {
        for (var i = 0; i < this.data.length; i++) {
          if (this.data[i].categoryId === index1) {
            for (var j = 0; j < this.data[i].detail.length; j++) {
              if (this.data[i].detail[j].subCategoryId === index2) {
                this.data[i].detail[j].isEditing = !this.data[i].detail[j].isEditing
              }
            }
          }
        }
      }
    }
  }
</script>

<style scoped>

  .section_category_title {
    background: #F4F6F9;
    border: 1px solid #D8DDE6;
    font-family: Lato;
    font-weight: 400;
    font-size: 18px;
    color: #002D41;
    text-align: left;
    padding: 28px 30px 24px 30px;
  }

  .section_category_content {
    padding: 24px 30px 0px 30px;
  }

  .section_subcategory_title {
    font-family: Lato;
    font-size: 14px;
    color: #002D41;
    font-weight: 700;
    text-align: left;
  }

  .section_subcategory_content {
    padding-left: 30%;
    padding-right: 30%;
    display: flex;
    flex-flow: wrap;
    border-bottom: 1px solid rgba(0,0,0,0.12);
  }

  .section_table_cell {
    width: 50%;
    padding-left: 10px;
    padding-right: 10px;
    display: inline-grid;
    text-align: left;
  }

  .section_subcategory_edit {
    margin-right: 20px;
  }
</style>

<style>
  .expand-enter-active {
    max-height: 1000px;
    transition-property: max-height;
    transition-duration: 1s;
    overflow: hidden;
  }
  .expand-leave-active {
    max-height: 1000px;
    transition-property: max-height;
    transition-duration: 1s;
    overflow: hidden;
  }

  /* .expand-enter defines the starting state for entering */
  /* .expand-leave defines the ending state for leaving */
  .expand-enter, .expand-leave-to {
    max-height: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/demo/components/sections/basicInformation.vue